import React from "react";
import downIcon from "../../../../assets/images/classes/downIcon.svg";
import {useNavigate} from "react-router-dom";

const DropDownStageType = ({
                            stageMenu,
                            setStageMenu,
                            openDropdown,
                            setOpenDropdown,
                            types
                        }) => {
    const isOpen = openDropdown === "type"; // ✅ 현재 열린 드롭다운이 "lesson"인지 확인

    const navigate = useNavigate();


    return (
        <div className="relative">
            <button
                onClick={() => setOpenDropdown(isOpen ? null : "type")} // ✅ 클릭 시 다른 드롭다운 닫기
                className="inline-flex w-[180px] h-[44px] justify-center items-center gap-x-1.5 rounded-[10px] bg-white px-3 py-2 font-[500] text-[18px] text-[#000] shadow-custom ring-1 ring-inset ring-gray-300 hover:bg-gray-50 z-20 relative"
            >
                <div className="text-left w-[90%] truncate pr-2">
                    {stageMenu && stageMenu.typeName ? stageMenu.typeName : "차시 선택"}
                </div>
                <img src={downIcon} alt="downIcon" className="ml-auto mr-[0px] w-4" />
            </button>

            {isOpen && (
                <div className="absolute w-full z-10 origin-top rounded-b-[10px] bg-white shadow-lg ring-1 ring-black/5 transition-all duration-300 overflow-hidden mt-[-8px] scrollbar-hide max-h-[300px] opacity-100">
                    <div className="max-h-[300px] overflow-y-auto bg-[#F1F1F1] pt-2">
                        {types && types.map((type, index) => (
                            <div
                                key={index}
                                className="cursor-pointer hover:bg-blue-50 p-2 truncate text-left ml-[10px]"
                                onClick={() => {
                                        setStageMenu(type);
                                        navigate(type.page);
                                        setOpenDropdown(null); // ✅ 선택 후 드롭다운 닫기

                                }}
                            >
                                {type.typeName}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DropDownStageType;
